<template>
  <div id="app" v-if="deviceready">
    <Header id="nav" />
    <b-progress height="3px" class="progbar" variant="dark"
      v-show="$store.getters.loadingPercent > 0"
      :value="$store.getters.loadingPercent" 
    />
    <div id="main" ref="main">
      <router-view/>
    </div>
 </div>
</template>

<script>
// import './canvas'
import Header from '@/components/Header'

export default {
  data () {
    return {
      deviceready: false,
      canvas: true
    }
  },
  components: {
    Header
  },
  created () {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('mac os x') !== -1 || ua.indexOf('windows nt') !== -1) {
      this.onDeviceReady()
    } else {
      document.addEventListener('deviceready', this.onDeviceReady, false)
    }
  },
  methods: {
    onDeviceReady () {
      this.deviceready = true
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  height: 100%;
}

.progbar {
  position: fixed;
  width: 100vw;
  z-index: 9998;
}

#nav {
  width: 100%;
  // padding: 30px;

  // a {
  //   font-weight: bold;
  //   color: #2c3e50;

  //   &.router-link-exact-active {
  //     color: #42b983;
  //   }
  // }
}

#main{
  width: 100%;
  height: 100%;

  padding-top: 75px; 

  display: flex;
  justify-content: center;
}

@media screen {
  .disp_side{
    width: 500px;
    min-height: 100%;
    margin: 0 auto;
  }
  .right {
    margin: 0 0 0 auto;
    right: 0;
  }
  #app {
    min-width: 640px;
  }
}
@media (min-width: 1000px) {
  .disp_side{
    width: 64%;
    min-height: 100%;
    margin: 0 auto;
  }
  .right {
    width: 500px;
    margin: 0 0 0 auto;
    right: 0;
  }
}


</style>
